import { proxy } from 'valtio';

// Define the dealer store type
export interface DealerStore {
  dealerId: string;
  setDealerId: (id: string) => void;
}

// 21282fba-efaa-40cb-9ca2-074a1e7d6af2 is the dealer id for autopiloteecars.com and in autopilotee.com is the jidosoju+1@gmail.com

const dealerId =
  process.env.REACT_APP_API_ENV === 'production'
    ? 'b5326e2f-2d2e-493a-9ec1-04b0938b1d69'
    : '7e48ec1f-1e38-4d23-be8f-4bf21c9a6d4a';

// Create the store with a default dealer ID and setter function
export const dealerStore = proxy<DealerStore>({
  dealerId, // Default dealer ID
  setDealerId: (id: string) => {
    dealerStore.dealerId = id;
  },
});
